var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, NgZone, OnInit, Renderer2 } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { CommunicationService } from '../../../services/communication.service';
import { Router } from '@angular/router';
import { LoginResult, LoginService } from '../../../services/login.service';
import { TranslateService } from '@ngx-translate/core';
import { SocialType } from '../../../classes/enums';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { CustomValidators } from '../../../classes/custom-validators';
import { emailRegex } from '../../../classes/leads';
import { DomManipulationService } from '../../../services/dom-manipulation/dom-manipulation.service';
import { RECAPTCHA_SCRIPT } from '../../../classes/dynamicScripts';
import { PreRenderService } from '../../../services/pre-render.service';
var SignInComponent = /** @class */ (function () {
    function SignInComponent(userService, communicationService, domManipulationService, _loginService, router, _translateService, zone, renderer, prerenderService) {
        this.userService = userService;
        this.communicationService = communicationService;
        this.domManipulationService = domManipulationService;
        this._loginService = _loginService;
        this.router = router;
        this._translateService = _translateService;
        this.zone = zone;
        this.renderer = renderer;
        this.prerenderService = prerenderService;
        this.showForgotPassword = new EventEmitter();
        this.continueWithSocialLogin = new EventEmitter();
        this.accounts = [];
        this.existingAccounts = '';
        this.showPasswordText = false;
        this.showConfirmPasswordText = false;
        this.buttonMessage = '';
        this.loginMode = true;
        this.isLoading = false;
        this.hasFacebook = false;
        this.hasGoogle = false;
        this.hasEmail = false;
        // enums
        this.SocialType = SocialType;
        // Store the url we came from in order to send the user back after a successful login.
        // remove the popup data from the url
        this.returnToUrl = this.router.routerState.snapshot.url.replace(/\(.*\)/, '');
        this.loginForm = new FormGroup({
            email: new FormControl('', { validators: [Validators.required, Validators.pattern(emailRegex)], updateOn: 'change' }),
            password: new FormGroup({
                password: new FormControl('', { validators: [Validators.required, Validators.minLength(6)], updateOn: 'change' }),
                confirmPassword: new FormControl('', { validators: [Validators.minLength(6)], updateOn: 'change' })
            }),
            termsAndCond: new FormControl('', [Validators.required]),
            rememberMe: new FormControl(true)
        });
    }
    SignInComponent.prototype.ngOnInit = function () {
        if (this.prerenderService.isBrowserMode) {
            this.renderer.addClass(document.querySelector('html'), 'no-scroll');
        }
        if (this.email) {
            this.loginForm.controls['email'].setValue(this.email);
        }
    };
    SignInComponent.prototype.sendGrecaptcha = function () {
        var _this = this;
        this.domManipulationService.loadScript(RECAPTCHA_SCRIPT).subscribe(function () {
            grecaptcha.execute(_this.recaptchaId);
        });
    };
    SignInComponent.prototype.getOnSubmit = function () {
        return this.onSubmit.bind(this);
    };
    SignInComponent.prototype.close = function () {
        this.renderer.removeClass(document.querySelector('html'), 'no-scroll');
        this.communicationService.showSignIn.next(false);
    };
    SignInComponent.prototype.setLoginMode = function (mode) {
        if (mode)
            this.loginForm.get('password').clearValidators();
        else
            this.loginForm.get('password').setValidators(CustomValidators.passwordMatcher);
        this.loginMode = mode;
    };
    /**
     * Called from onSubmit after the user clicks the login/register button, so we know they are not doing a social login.
     * @param isNewlyRegistered
     */
    SignInComponent.prototype.login = function (isNewlyRegistered) {
        var _this = this;
        if (isNewlyRegistered === void 0) { isNewlyRegistered = false; }
        this.setLoginAttempt(SocialType.NotSocial);
        this.userService.checkUserAccounts(this.userEmail.value).then(function (response) {
            if (response.filter(function (r) { return r === SocialType.NotSocial; })) {
                _this.continueWithLogin(isNewlyRegistered);
                return;
            }
            _this.showUserMessage(response);
        }).catch(function (error) {
            if (error.status === 404) {
                _this.continueWithLogin(isNewlyRegistered);
            }
        });
    };
    /**
     * We've detected the email they are trying to log in with has already been used to register a social account with.
     * @param accounts
     */
    SignInComponent.prototype.showUserMessage = function (accounts) {
        var _this = this;
        this.accounts = accounts;
        this.hasFacebook = accounts.indexOf(SocialType.Facebook) > -1;
        this.hasGoogle = accounts.indexOf(SocialType.Google) > -1;
        this.hasEmail = accounts.indexOf(SocialType.NotSocial) > -1;
        this.zone.run(function () {
            _this.error = 'sign-in.email-exists';
            _this.existingAccounts = '';
            for (var i = 0; i < accounts.length; i++) {
                _this.existingAccounts += _this.getAccountName(accounts[i]) + ' ';
                if (i < accounts.length - 1) {
                    _this.existingAccounts += _this._translateService.instant('sign-in.and') + ' ';
                }
            }
        });
    };
    SignInComponent.prototype.setLoginAttempt = function (loginAttempt) {
        this.loginAttempt = loginAttempt;
        switch (this.loginAttempt) {
            case SocialType.NotSocial:
                this.buttonMessage = 'Credentials';
                break;
            case SocialType.Facebook:
                this.buttonMessage = 'Facebook';
                break;
            case SocialType.Google:
                this.buttonMessage = 'Google';
                break;
        }
    };
    /**
     * This will either switch the login attempt to registration, or if we are doing a social login, we have confirmed with the user
     * that they want to continue (they already have other another account registered with us)
     */
    SignInComponent.prototype.continueLogin = function () {
        switch (this.loginAttempt) {
            case SocialType.NotSocial:
                this.switchToRegistration();
                break;
            case SocialType.Facebook:
            case SocialType.Google:
                this.continueWithSocialLogin.next(this.loginAttempt);
                break;
        }
    };
    /**
     * This is called after we have confirmed they have a non-social account or do not yet have an account.
     * @param isNewlyRegistered
     */
    SignInComponent.prototype.continueWithLogin = function (isNewlyRegistered) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.isLoading = true;
                this._loginService.login(this.userEmail.value, this.password.value, this.rememberMe.value).subscribe(function (result) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (result === LoginResult.LoggedIn) {
                            // This should take them to the page they were on before they tried to login.
                            this.router.navigateByUrl(this.returnToUrl);
                            this.communicationService.navigation.toggleNavs.next({ left: false, right: false });
                            // Remove anything that might have taken away scrolling
                            this.renderer.removeClass(document.querySelector('html'), 'no-scroll');
                            this.close();
                        }
                        else if (result === LoginResult.InvalidCredentails) {
                            this.error = 'registration.invalid-username-password';
                        }
                        else if (result === LoginResult.NewUserRequiresPasswordChange) {
                            this.error = 'registration.migrated-user';
                        }
                        else if (result === LoginResult.UserNotFound) {
                            this.setLoginMode(false);
                        }
                        else {
                            this.error = 'unexpected-error';
                        }
                        this.isLoading = false;
                        return [2 /*return*/];
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    /**
     * Called when the user clicks the login/register button.
     */
    SignInComponent.prototype.onSubmit = function (recaptchaKey) {
        var _this = this;
        if (this.loginMode) {
            this.login(false);
        }
        else {
            var value = this.loginForm.value;
            value.password = this.password.value;
            value.confirmPassword = this.confirmPassword.value;
            this.userService.registerUser(value, recaptchaKey).then(function (data) {
                // If they successfully register, automatically log them in.
                _this.login(true);
            }).catch(function (error) {
                _this.error = error.error ? error.error.message : JSON.parse(error['_body']).message;
            });
        }
    };
    SignInComponent.prototype.getAccountName = function (account) {
        if (account === SocialType.Facebook)
            return 'Facebook';
        if (account === SocialType.Google)
            return 'Google';
        if (account === SocialType.NotSocial)
            return 'Email';
    };
    SignInComponent.prototype.switchToEmail = function () {
        this.error = '';
        this.accounts = [];
    };
    SignInComponent.prototype.switchToRegistration = function () {
        this.error = '';
        this.loginMode = false;
        this.accounts = [];
    };
    Object.defineProperty(SignInComponent.prototype, "password", {
        get: function () {
            return this.loginForm.get('password').get('password');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignInComponent.prototype, "confirmPassword", {
        get: function () {
            return this.loginForm.get('password').get('confirmPassword');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignInComponent.prototype, "userEmail", {
        get: function () {
            return this.loginForm.get('email');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignInComponent.prototype, "passwordFormGroup", {
        get: function () {
            return this.loginForm.get('password');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignInComponent.prototype, "rememberMe", {
        get: function () {
            return this.loginForm.get('rememberMe');
        },
        enumerable: true,
        configurable: true
    });
    return SignInComponent;
}());
export { SignInComponent };
var LoginOrRegister = /** @class */ (function () {
    function LoginOrRegister() {
        this.rememberMe = true;
    }
    return LoginOrRegister;
}());
export { LoginOrRegister };
